var e = /* @__PURE__ */ ((r) => (r.Header = "HEADER", r.Footer = "FOOTER", r))(e || {});
export {
  e as ExternalResourcePositions
};
//# sourceMappingURL=index2.js.map
